<template>
  <div class="home_page container" v-loading="reqLoading">
    <PageRoute />
    <!-- 搜索组件 -->
    <CommonSearch @postSearchParams="postSearchParams"></CommonSearch>

    <!-- 排序 -->
    <el-row class="good_sort" v-if="goodList.length > 0">
      <span class="goods_nums"
        >共<big>{{ total }}</big
        >种商品</span
      >
      <img
        width="24px"
        :src="require('@/assets/img/table-active.svg')"
        v-if="showBigPic"
      />
      <img
        width="24px"
        :src="require('@/assets/img/table.svg')"
        @click="toggleListType"
        v-else
      />
      <img
        width="24px"
        :src="require('@/assets/img/list-active.svg')"
        v-if="!showBigPic"
      />
      <img
        width="24px"
        :src="require('@/assets/img/list.svg')"
        @click="toggleListType"
        v-else
      />
    </el-row>

    <good-list
      :goodList="goodList"
      :page="page"
      :total="total"
      @refushDataList="refushDataList"
      v-if="showBigPic"
    >
    </good-list>
    <good-list2
      :goodList="goodList"
      :page="page"
      :total="total"
      @refushDataList="refushDataList"
      v-if="!showBigPic"
    >
    </good-list2>
    <div class="no_show_message" v-show="!total">
      <img src="@/assets/img/good/noGood.png" :alt="$t('product.noGoods')" />
      <div>{{ $t("product.noGoods") }}</div>
    </div>
    <!-- 回到顶部 -->
    <!-- <backToTop /> -->
    <SupportIcon />
  </div>
</template>
<script>
import PageRoute from './components/pageRoute.vue'
import GoodList from './components/goodList.vue'
import GoodList2 from './components/goodList2.vue'
import SupportIcon from './components/supportIcon.vue'
import CommonSearch from './components/commonSearch.vue'
export default {
  data () {
    return {
      searchParams: {},
      spuType: 'lectotype', // spu （普通商品）,lectotype （选型商品）
      reqLoading: false,
      goodList: [],
      page: 1,
      total: 0,
      showBigPic: true // true-大图，false-列表
    }
  },
  components: {
    CommonSearch,
    SupportIcon,
    GoodList,
    GoodList2,
    PageRoute
  },
  computed: {},
  methods: {
    // 查询商品列表及数据条数
    refushDataList (page = this.page, reset = true) {
      if (this.reqLoading) {
        return false
      }
      this.reqLoading = true
      this.page = page
      this.$http
        .post(`/front/cross/commodity-user/web/spu-list?spuType=lectotype`, {
          limit: 20,
          page: page,
          ...this.searchParams
        })
        .then(({ data: res }) => {
          this.reqLoading = false
          if (res.code !== 0) {
            this.goodList = []
            this.total = 0
            return false
          }
          this.goodList = res.data.dataList || []
          this.total = res.data.count
        })
        .catch(() => {
          this.reqLoading = false
          this.goodList = []
          this.total = 0
        })
    },
    toggleListType () {
      this.showBigPic = !this.showBigPic
    },
    postSearchParams (params) {
      this.searchParams = params
      this.refushDataList(1)
    }
  }
}
</script>
<style lang="scss" scoped>
.home_page {
  padding: 0 0 20px 0;
  width: 1200px;
  /deep/ .loading-mask {
    pointer-events: none;
  }
}

.good_sort {
  margin: 0 0 20px;
  line-height: 32px;
  color: #666666;
  border-radius: 12px;
  display: flex;
  padding: 10px 20px;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.06);
  font-size: 14px;
  justify-content: flex-end;

  .goods_nums {
    vertical-align: sub;
    margin-right: 28px;

    big {
      font-size: 18px;
      font-weight: bold;
      color: #2a54d1;
      margin: 0 4px;
    }
  }

  img {
    margin-right: 16px;
    cursor: pointer;
    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
